import { MutationTree } from "vuex";
import { AuthState, AuthUser } from "./types";

export const mutations: MutationTree<AuthState> = {
  setUser(state, user: AuthUser) {
    state.authUser = user;
  },
};
